import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import FamikarHeader from '../components/FamikarHeader';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

let uid = '';          // 招待送信者のuidを格納する
let tmpFamilyIDs = []; // FamilyIDを格納

export default function InvitationList() {
  const navigate = useNavigate();
  const {familyID} = useParams();
  const [IsLogin, setIsLogin] = useState(false);
  const [Uid, setUid] = useState('');
  const [FamilyID, setFamilyID] = useState(familyID ? familyID : '');
  const [InvitationList, setInvitationList] = useState([]);
  const [Loading, setLoading] = useState(true);
  
  // モーダル関連の状態
  const [openResendModal, setOpenResendModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openCompleteModal, setOpenCompleteModal] = useState(false);
  const [openCancelCompleteModal, setOpenCancelCompleteModal] = useState(false);
  const [selectedInvitation, setSelectedInvitation] = useState(null);

  // ログイン情報取得
  const getLoginInfo = (db) => {
    console.log("InvitationList.js getLoginInfo()");
    Promise.resolve().then(() => {
      return new Promise((resolve) => {
        firebase.auth().onAuthStateChanged((user) => { // 現在ログインしているユーザーを取得する
          if (user) {
            uid = user.uid; // ログインユーザーのuidを取得する
            setIsLogin(true);
            resolve();
          }
        });
      });
    })
    .then(() => {
      return new Promise((resolve) => {
        if (FamilyID === '') {
          db.collection("Person").doc(uid).get().then((Person_result) => { // ログインユーザー情報から、家族IDの情報を取得する
            tmpFamilyIDs.push(Person_result.data().FamilyID[0].id); // 1件目の家族IDを取得する
            window.history.replaceState(null, null, "/InvitationList/" + tmpFamilyIDs[0]); // URLに家族IDが含まれない場合は、家族IDを含むURLに書き替えを行う
            resolve();
          });
        } else {
          tmpFamilyIDs.push(FamilyID); // 1件目の家族IDを取得する
          resolve();
        }
      });
    })
    .then(() => {
      setUid(uid);
      setFamilyID(tmpFamilyIDs[0]);
      getInvitationList(db); // 招待情報取得
    });
  };

  // 現在の日付を取得
  const now = new Date();
  
  // 2週間後の日付を計算する関数
  const getTwoWeeksLater = (date) => {
    const twoWeeksLater = new Date(date);
    twoWeeksLater.setDate(twoWeeksLater.getDate() + 14);
    return twoWeeksLater;
  };
  
  // 有効期限が切れているかチェックする関数
  const isExpired = (expiration) => {
    return expiration < now;
  };

  // 招待情報取得
  const getInvitationList = (db) => {
    setLoading(true);
    
    db.collection("Family").doc(tmpFamilyIDs[0]).collection("Invitation")
      .orderBy("CreateTime", "asc") // 作成日時の新しい順に取得
      .get()
      .then((result) => {
        const invitations = [];
        let counter = 1;
        result.forEach((doc) => {
          const data = doc.data();
          invitations.push({
            no: counter++,
            id: doc.id, // ドキュメントID
            Invitation_Email: data.Invitation_Email || '', // 招待対象者のEメールアドレス
            createTime: data.CreateTime ? data.CreateTime.toDate() : null,
            updateTime: data.UpdateTime ? data.UpdateTime.toDate() : null,
            expiration: data.Expiration ? data.Expiration.toDate() : null,
            invitationName: data.Invitation_Name || '',
            active: data.Active || false,
            completion: data.Completion || false
          });
        });
        setInvitationList(invitations);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error getting invitation documents: ", error);
        setLoading(false);
        alert('招待情報の取得に失敗しました。');
      });
  };

  // 招待画面に戻る
  const handleGoToInvitation = () => {
    navigate('/Invitation/' + FamilyID);
  };

  // トップ画面に戻る
  const handleGoToTop = () => {
    navigate('/FamilyHome/' + FamilyID);
  };

  // 再送リンククリック時の処理
  const handleResendClick = (invitation) => {
    setSelectedInvitation(invitation);
    setOpenResendModal(true);
  };

  // 取消リンククリック時の処理
  const handleCancelClick = (invitation) => {
    setSelectedInvitation(invitation);
    setOpenCancelModal(true);
  };

  // 招待再送処理
  const handleResendInvitation = () => {
    if (!selectedInvitation) return;
    
    console.log("招待を再送します: ", selectedInvitation.Invitation_Email);
    
    const db = firebase.firestore();
    // 招待情報の更新日時と有効期限を更新
    const twoWeeksLater = new Date();
    twoWeeksLater.setDate(twoWeeksLater.getDate() + 14);
    
    // Family/(FamilyID)/Invitation/(InvitationID) の更新
    db.collection("Family").doc(FamilyID).collection("Invitation").doc(selectedInvitation.id)
      .update({
        UpdateTime: firebase.firestore.FieldValue.serverTimestamp(),
        Expiration: firebase.firestore.Timestamp.fromDate(twoWeeksLater),
        Active: true
      })
      .then(() => {
        // Invitation/(InvitationID) の更新
        return db.collection("Invitation").doc(selectedInvitation.id)
          .update({
            UpdateTime: firebase.firestore.FieldValue.serverTimestamp(),
            Expiration: firebase.firestore.Timestamp.fromDate(twoWeeksLater),
            Active: true
          });
      })
      .then(() => {
        // SendEmail コレクションにメール送信情報を登録
        const sendEmailID = db.collection('SendEmail').doc().id;
        const sendEmailData = {
          to: [selectedInvitation.Invitation_Email], // 受信者メールアドレス（配列形式）
          message: {
            subject: `【ふぁみかるくん】招待の再送`, // メールの件名
            text: `${selectedInvitation.invitationName ? selectedInvitation.invitationName + " 様" : ""}

ふぁみかるくんアプリへの招待を再送します。

招待を受け取り、${selectedInvitation.invitationName ? selectedInvitation.invitationName + " 様" : ""}の家族として家族の健康情報を共同管理するには、
以下のリンクより登録を行ってください。
http://app.famikar.jp/InvitationAccept?InvitationID=${selectedInvitation.id}

このメールを誤って受け取った場合は。お手数ですが、下記のメールアドレスまでご連絡ください。
info@famikar.jp

以上

----
家族の健康情報家族内共有アプリ　ふぁみかるくん
info@famikar.jp
運営元：株式会社GoMeTo`
          },
          CreateTime: firebase.firestore.FieldValue.serverTimestamp() // 作成日時
        };
        
        return db.collection("SendEmail").doc(sendEmailID).set(sendEmailData);
      })
      .then(() => {
        console.log("招待を再送しました");
        // 招待情報を再取得
        getInvitationList(db);
        setOpenResendModal(false);
        // 完了モーダルを表示
        setOpenCompleteModal(true);
      })
      .catch((error) => {
        console.error("Error resending invitation: ", error);
        setOpenResendModal(false);
        alert('招待の再送に失敗しました。');
      });
  };

  // 招待取消処理
  const handleCancelInvitation = () => {
    if (!selectedInvitation) return;
    
    console.log("招待を取り消します: ", selectedInvitation.Invitation_Email);
    
    const db = firebase.firestore();
    // 招待情報の有効フラグを無効に更新
    
    // Family/(FamilyID)/Invitation/(InvitationID) の更新
    db.collection("Family").doc(FamilyID).collection("Invitation").doc(selectedInvitation.id)
      .update({
        UpdateTime: firebase.firestore.FieldValue.serverTimestamp(),
        Active: false
      })
      .then(() => {
        // Invitation/(InvitationID) の更新
        return db.collection("Invitation").doc(selectedInvitation.id)
          .update({
            UpdateTime: firebase.firestore.FieldValue.serverTimestamp(),
            Active: false
          });
      })
      .then(() => {
        console.log("招待を取り消しました");
        // 招待情報を再取得
        getInvitationList(db);
        setOpenCancelModal(false);
        // 取消完了モーダルを表示
        setOpenCancelCompleteModal(true);
      })
      .catch((error) => {
        console.error("Error canceling invitation: ", error);
        setOpenCancelModal(false);
        alert('招待の取消に失敗しました。');
      });
  };

  useEffect(() => { // ページ表示時、情報更新時に実行
    // componentDidMount のタイミングで実行したい処理を記述
    const db = firebase.firestore();
    getLoginInfo(db); // ログイン情報取得
    // 次の行のコメントでeslintの余分なワーニングを抑制する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { // ページを離れる際に実行
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん'; // 画面を離れる際、ページタイトルを初期値に戻す
    };
  }, []);

  return (
    <React.Fragment>
      {
        /* uidに値がある場合のみヘッダー表示を行う */
        uid && <FamikarHeader uid={uid} FamilyID={FamilyID} isHome={true} />
      }
      <Grid container direction="column" spacing={2} style={{padding: '16px'}}>
        {/* タイトル */}
        <Grid item xs={12}>
          <Typography variant="h6" style={{marginBottom: '8px'}}>
            家族・関係者登録の依頼・取消
          </Typography>
        </Grid>
        
        {/* 画面説明 */}
        <Grid item xs={12}>
          <Typography variant="body1" style={{marginBottom: '16px'}}>
            招待済みの家族について表示します。
          </Typography>
        </Grid>
        
        {/* 招待済み家族一覧 */}
        <Grid item xs={12} style={{marginBottom: '80px'}}>
          <Typography variant="h6" style={{marginBottom: '8px'}}>
            招待済みの家族一覧
          </Typography>
          
          {Loading ? (
            <Typography>読み込み中...</Typography>
          ) : InvitationList.length === 0 ? (
            <Paper style={{padding: '16px', marginBottom: '16px'}}>
              <Typography>招待情報がありません</Typography>
            </Paper>
          ) : (
            <TableContainer component={Paper}>
              <Table aria-label="招待一覧テーブル">
                <TableHead>
                  <TableRow>
                    <TableCell style={{width: '10%', minWidth: '40px', padding: '8px'}}>no</TableCell>
                    <TableCell style={{width: '35%', minWidth: '120px', wordBreak: 'break-all', whiteSpace: 'normal', padding: '8px'}}>Eメールアドレス</TableCell>
                    <TableCell style={{width: '25%', minWidth: '80px', wordBreak: 'break-word', whiteSpace: 'normal', padding: '8px'}}>名前</TableCell>
                    <TableCell style={{width: '15%', minWidth: '60px', padding: '8px'}}>依頼</TableCell>
                    <TableCell style={{width: '15%', minWidth: '60px', padding: '8px'}}>取消</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {InvitationList.filter(invitation => invitation.active).map((invitation) => (
                    <TableRow key={invitation.id}>
                      <TableCell style={{width: '10%', minWidth: '40px', padding: '8px'}}>{invitation.no}</TableCell>
                      <TableCell style={{width: '35%', minWidth: '120px', wordBreak: 'break-all', whiteSpace: 'normal', padding: '8px'}}>{invitation.Invitation_Email}</TableCell>
                      <TableCell style={{width: '25%', minWidth: '80px', wordBreak: 'break-word', whiteSpace: 'normal', padding: '8px'}}>{invitation.invitationName}</TableCell>
                      <TableCell style={{width: '15%', minWidth: '60px', padding: '8px'}}>
                        {invitation.completion ? (
                          "完了"
                        ) : (
                          <Link 
                            component="button"
                            variant="body2"
                            onClick={() => handleResendClick(invitation)}
                          >
                            {isExpired(invitation.expiration) ? '再依頼' : '再送'}
                          </Link>
                        )}
                      </TableCell>
                      <TableCell style={{width: '15%', minWidth: '60px', padding: '8px'}}>
                        {invitation.completion ? (
                          "-"
                        ) : (
                          <Link 
                            component="button"
                            variant="body2"
                            onClick={() => handleCancelClick(invitation)}
                          >
                            取消
                          </Link>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>

      {/* 画面下部のボタン */}
      <AppBar position="fixed" style={{backgroundColor: '#FFFFFF', top: 'auto', bottom: '0', boxShadow: 'none'}}>
        <Grid container justifyContent="space-between" alignItems="flex-start" style={{padding: '16px 8px 8px', maxWidth: '480px'}} className="App">
          <Button variant="contained" color="primary" onClick={handleGoToInvitation}>招待画面に戻る</Button>
          <Button variant="contained" color="primary" onClick={handleGoToTop}>トップ画面</Button>
        </Grid>
      </AppBar>

      {/* 招待依頼用モーダル・確認 */}
      <Dialog
        open={openResendModal}
        onClose={() => setOpenResendModal(false)}
        aria-labelledby="resend-dialog-title"
        aria-describedby="resend-dialog-description"
      >
        <DialogTitle id="resend-dialog-title">招待の再送</DialogTitle>
        <DialogContent>
          <DialogContentText id="resend-dialog-description">
            こちらの家族への招待を送りますか。
          </DialogContentText>
          <Typography variant="body1" style={{marginTop: '16px'}}>
            {selectedInvitation && `${selectedInvitation.Invitation_Email}`}
            {selectedInvitation && selectedInvitation.invitationName && `(${selectedInvitation.invitationName}さん)`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResendModal(false)} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleResendInvitation} color="primary" autoFocus>
            招待を送信
          </Button>
        </DialogActions>
      </Dialog>

      {/* 招待取消用モーダル */}
      <Dialog
        open={openCancelModal}
        onClose={() => setOpenCancelModal(false)}
        aria-labelledby="cancel-dialog-title"
        aria-describedby="cancel-dialog-description"
      >
        <DialogTitle id="cancel-dialog-title">招待の取消</DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-dialog-description">
            こちらの家族への招待を取り消しますか。
          </DialogContentText>
          <Typography variant="body1" style={{marginTop: '16px'}}>
            {selectedInvitation && `${selectedInvitation.Invitation_Email}`}
            {selectedInvitation && selectedInvitation.invitationName && `(${selectedInvitation.invitationName}さん)`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCancelModal(false)} color="primary">
            キャンセル
          </Button>
          <Button onClick={handleCancelInvitation} color="primary" autoFocus>
            招待を取消
          </Button>
        </DialogActions>
      </Dialog>

      {/* 招待依頼用モーダル・完了 */}
      <Dialog
        open={openCompleteModal}
        onClose={() => setOpenCompleteModal(false)}
        aria-labelledby="complete-dialog-title"
        aria-describedby="complete-dialog-description"
      >
        <DialogTitle id="complete-dialog-title">招待送信完了</DialogTitle>
        <DialogContent>
          <DialogContentText id="complete-dialog-description">
            下記の通り、招待を送信しました
          </DialogContentText>
          <Typography variant="body1" style={{marginTop: '16px'}}>
            {selectedInvitation && `${selectedInvitation.Invitation_Email}`}
            {selectedInvitation && selectedInvitation.invitationName && `(${selectedInvitation.invitationName}さん)`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenCompleteModal(false);
            navigate('/InvitationList/' + FamilyID);
          }} color="primary">
            招待家族一覧
          </Button>
          <Button onClick={() => {
            setOpenCompleteModal(false);
            navigate('/FamilyHome/' + FamilyID);
          }} color="primary" autoFocus>
            トップ画面へ
          </Button>
        </DialogActions>
      </Dialog>

      {/* 招待取消用モーダル・完了 */}
      <Dialog
        open={openCancelCompleteModal}
        onClose={() => setOpenCancelCompleteModal(false)}
        aria-labelledby="cancel-complete-dialog-title"
        aria-describedby="cancel-complete-dialog-description"
      >
        <DialogTitle id="cancel-complete-dialog-title">招待取消完了</DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-complete-dialog-description">
            下記の通り、招待を取り消しました
          </DialogContentText>
          <Typography variant="body1" style={{marginTop: '16px'}}>
            {selectedInvitation && `${selectedInvitation.Invitation_Email}`}
            {selectedInvitation && selectedInvitation.invitationName && `(${selectedInvitation.invitationName}さん)`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenCancelCompleteModal(false);
            navigate('/InvitationList/' + FamilyID);
          }} color="primary">
            招待家族一覧
          </Button>
          <Button onClick={() => {
            setOpenCancelCompleteModal(false);
            navigate('/FamilyHome/' + FamilyID);
          }} color="primary" autoFocus>
            トップ画面へ
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
